module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/root.6b4ae6c8b4664ab184d64b23c2951ee8-ccahPlaceHolder-d1800.jpg";